import { globalStyles as customGlobalStyles, typography as customTypography } from '@limitless-minds/ui-styles'
import { CssBaseline, GlobalStyles } from '@mui/material'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router-dom'

import { ReactQueryProvider } from '@/data/api'
import AppLayout from '@/layouts/AppLayout'
import { router } from '@/router'
import ColorSchemeProvider from '@/theme/ColorSchemeProvider'

/**
 * The theme is built in `@/theme` rather than here, because `verify:color-mode` imports that module under
 * Node to assert what the built theme holds. A theme constructed inside a component file cannot be
 * reached that way.
 *
 * `CssBaseline` stays, and with two colour schemes it earns more than it did with one: it is what writes
 * `background.default` and `text.primary` onto `body`, and `color-scheme` per scheme, so the form controls
 * the browser draws itself follow the mode too. What it cannot do is paint before React mounts - Emotion
 * injects its sheet at that point by definition - which is why `index.html` carries a static sheet as
 * well.
 */
export default function RootLayout(): JSX.Element {
  return (
    <ReactQueryProvider>
      <ColorSchemeProvider>
        <CssBaseline />
        <GlobalStyles styles={customGlobalStyles} />
        <GlobalStyles styles={customTypography} />
        <AppLayout>
          <RouterProvider router={router} />
        </AppLayout>
      </ColorSchemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </ReactQueryProvider>
  )
}
